import { useMemo } from "react";

import { GenericExperienceFe } from "@intelligems/ig-types";

import { useGetExperiencesList } from "@src/api/experiences-list/get-experiences-list";

import { audiencesAreEquivalent } from "@src/utils/audienceEquality";

export const useHasLivePostPurchaseWithSameAudience = (
  experience: GenericExperienceFe
) => {
  const experiments = useGetExperiencesList({ category: "experiment" });
  const personalizations = useGetExperiencesList({
    category: "personalization",
  });

  return useMemo(() => {
    if (!experience.testTypes?.hasTestPostPurchase) {
      return false;
    }
    const all = [
      ...(experiments.data?.experiencesList ?? []),
      ...(personalizations.data?.experiencesList ?? []),
    ];
    return all.some(
      (other) =>
        other.id !== experience.id &&
        other.status === "started" &&
        other.testTypes.hasTestPostPurchase &&
        other.audience?.enabled !== false &&
        audiencesAreEquivalent(other.audience, experience.audience)
    );
  }, [experience, experiments.data, personalizations.data]);
};
